import React from 'react';

import { LayoutRenderer } from './types';
import { buildTilePlaceholder } from './utils';

export const HeroOneLayout: LayoutRenderer = ({ children, placeholder }) => {
  const nodes = React.Children.toArray(children).filter(Boolean);
  const [media] = nodes;

  const mediaContent = media ?? buildTilePlaceholder(placeholder, 'hero-1-media', 'hero');

  return (
    <div className="itv-row-collection__hero1">
      <div className="itv-row-collection__hero1-media">{mediaContent}</div>
    </div>
  );
};
